import projects from './firebase-projects.json';
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Firebase config and core app initialization first (needed before messaging)
const appEnvironment = process.env.REACT_APP_ENV || 'production';
if (!['production', 'staging'].includes(appEnvironment)) throw new Error('Invalid REACT_APP_ENV');
const firebaseConfig = projects[appEnvironment];

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Messaging related exports (initialized later if environment supports it)
let messaging = null;

// Default no-op exports (will be reassigned once messaging is loaded)
let requestNotificationPermission = async () => null;
let onMessageListener = () => { };

// Conditionally (and lazily) load messaging without top-level await
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
    import("firebase/messaging")
        .then(({ getMessaging, getToken, onMessage }) => {
            try {
                messaging = getMessaging(app);

                requestNotificationPermission = async () => {
                    try {
                        const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || (appEnvironment === 'production' ? 'BLGXoc_PO4wcnejuGMIrzIH-GXy4kefb3gNVtlIhg_aRSyBEXCeM7s_8krXloI5JwjhGqeK3eTCyjw8Fn7-94uk' : '');
                        if (!vapidKey) return null;
                        const serviceWorkerRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
                        const token = await getToken(messaging, {
                            vapidKey, serviceWorkerRegistration
                        });
                        return token;
                    } catch (err) {
                        console.error("❌ Error getting FCM token:", err);
                        return null;
                    }
                };

                onMessageListener = (callback) => onMessage(messaging, callback);
            } catch (err) {
                console.warn("⚠️ Failed to initialize Firebase messaging:", err);
            }
        })
        .catch(() => {
            console.warn("⚠️ Firebase messaging not available in this environment");
        });
}

export { messaging, requestNotificationPermission, onMessageListener };